import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    static targets = ['input', 'output']

    declare readonly inputTarget: HTMLInputElement;
    declare readonly outputTarget: HTMLElement;

    update(event: Event) {
        // we need this to adapt the width of the input field
        this.outputTarget.textContent = this.inputTarget.value
    }


    async save(event: Event) {
        const form = this.element as HTMLFormElement;

        await fetch(form.action, {
            method: 'PATCH',
            body: new FormData(form),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
    }
}

